import { createReducer, createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
	getAffiliates: ['userId'],
	getAffiliatesDone: ['affiliates', 'message'],
	getAffiliatesError: ['errorMessage'],
	addAffiliate: ['userTargetId', 'affReqId'],
	addAffiliateDone: ['message'],
	addAffiliateError: ['errorMessage'],
	deleteAffiliate: ['affilatesId', 'targetId'],
	deleteAffiliateDone: ['message'],
	deleteAffiliateError: ['errorMessage'],
	changeAffiliateStatus: ['affiliationRequest'],
});

export const INITIAL_STATE = {
	affiliates: [],
	message: '',
	errorMessage: '',
	loading: false,
};

export const AffiliatesTypes = Types;
export default Creators;

const fetchRequest = (state) => ({
	...state,
	loading: true,
});

const getAffiliatesDone = (state, { affiliates, message }) => ({
	...state,
	loading: false,
	message,
	affiliates,
})

const showErrorMessage = (state, { errorMessage }) => ({
	...state,
	loading: false,
	errorMessage,
});

const showMessage = (state, { message }) => ({
	...state,
	message,
	loading: false,
})

export const reducer = createReducer(INITIAL_STATE, {
	[Types.GET_AFFILIATES]: fetchRequest,
	[Types.GET_AFFILIATES_DONE]: getAffiliatesDone,
	[Types.GET_AFFILIATES_ERROR]: showErrorMessage,
	[Types.ADD_AFFILIATE]: fetchRequest,
	[Types.ADD_AFFILIATE_DONE]: showMessage,
	[Types.ADD_AFFILIATE_ERROR]: showErrorMessage,
	[Types.DELETE_AFFILIATE]: fetchRequest,
	[Types.DELETE_AFFILIATE_DONE]: showMessage,
	[Types.DELETE_AFFILIATE_ERROR]: showErrorMessage,
});